import { throttle } from './_utils';
import Loader from './_loader';
import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only';
import { makeRequestRefactored } from '../common/utils';

const controller = new AbortController();
const controllerSignal = controller.signal;

export default function idle() {
  const timeBox = document.querySelector('.alert-box');
  const timeElement = document.querySelector('.alert-box .alert-time');
  const dataIdleMax = timeBox.getAttribute('data-idle-time');
  const idleMax = dataIdleMax ?? 300000; // 4 minutes or 240.000 miliseconds
  const idleMin = 10000; // 10 seconds
  const idleInterval = idleMax * 0.1; // 10% of the total time
  const mouseMove = idleInterval > idleMin ? idleInterval : idleMin;
  let idleWarning = idleMax * 0.80; // 75% of the total time
  let timerCurrent = idleMax * 0.20;
  let timerPopUp;
  let timerIdle;
  let timerWarning;

  startTimeouts();
  const loader = new Loader();

  document.addEventListener('mousemove', throttle(refreshToken.bind(null, timerIdle), mouseMove));
  document.addEventListener('mousedown', throttle(refreshToken.bind(null, timerIdle), mouseMove));
  document.addEventListener('touchmove', throttle(refreshToken.bind(null, timerIdle), mouseMove));
  document.addEventListener('touchstart', throttle(refreshToken.bind(null, timerIdle), mouseMove));

  function warningIdle() {
    const seconds = 1000;
    timerPopUp = setInterval(updateClock, seconds);
  }

  function updateClock() {
    if (!timerCurrent) return;
    timerCurrent -= 1000;

    const timerInSeconds = timerCurrent / 1000;
    let minutes = Math.floor(timerInSeconds / 60);
    let seconds = timerInSeconds % 60;

    minutes = minutes < 10 ? `0${minutes}` : minutes;
    seconds = seconds < 10 ? `0${seconds}` : seconds;

    timeElement.innerHTML = `${minutes}:${seconds}`;
    timeBox.style.opacity = 1;
    timeBox.removeAttribute('hidden');
  }

  function startTimeouts() {
    timerIdle = setTimeout(logout, idleMax);
    timerWarning = setTimeout(warningIdle, idleWarning);
  }

  function refreshToken() {
    const isHidden = timeBox.hasAttribute('hidden');
    if (!isHidden) {
      makeRequestRefactored('/refresh-session', 'POST', null, null, controllerSignal)
        .then((response) => {
          if (response.redirect_url) {
            window.location.href = response.redirect_url;
          }
        })
        .catch((err) => { // eslint-disable-line
          if (err.name === 'AbortError') {
            return null;
          }
        });

      clearTimeout(timerIdle);
      clearTimeout(timerWarning);
      clearTimeout(timerPopUp);
      startTimeouts();
      timerCurrent = idleMax * 0.20;
      idleWarning = idleMax * 0.80;
      timeBox.setAttribute('hidden', '');
    }
  }

  function logout() {
    clearTimeout(timerIdle);
    clearTimeout(timerWarning);
    clearTimeout(timerPopUp);
    setTimeout(() => {
      timeBox.style.opacity = 0;
    }, 400);
    timeBox.setAttribute('hidden', '');
    loader.show();

    makeRequestRefactored('/logout', 'POST')
      .then((response) => {
        if (response.redirect_url) {
          window.location.href = response.redirect_url;
        }
      })
      .catch((err) => { // eslint-disable-line
        if (err.name === 'AbortError') {
          return null;
        }
      });
  }
}
